import EventEmitter from 'src/libs/EventEmitter';
import { PPFDispatcher } from 'src/dispatcher';

const CHANGE_EVENT = 'CHANGE_EVENT';

export default class BaseStore extends EventEmitter {
  constructor() {
    super({ type: 'Store' });
    this.dispatchToken = PPFDispatcher.register(this.onDispatcherAction.bind(this));
  }

  emitChange(payload) {
    this.emit(CHANGE_EVENT, payload);
  }

  addChangeListener(fn) {
    this.on(CHANGE_EVENT, fn);
  }

  removeChangeListener(fn) {
    this.off(CHANGE_EVENT, fn);
  }

  onDispatcherAction() {
    console.warn(`
      If you are seeing this message, it is because you are extending \`BaseStore\`
        without overriding the \`onDispatcherAction\` method. Please do that
        in order to be able to subscribe to dispatched actions.
    `);
  }
}
